export * from '@elliemae/ds-tooltip';
export { default } from '@elliemae/ds-tooltip';
//# sourceMappingURL=index.js.map
